import { render, staticRenderFns } from "./eventRemotePage.vue?vue&type=template&id=19c26bca&"
import script from "./eventRemotePage.vue?vue&type=script&lang=ts&"
export * from "./eventRemotePage.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/muuq-base.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/css/muuq-fonts/style.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/slot.scss?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports